import { IoDiamondOutline } from "react-icons/io5";
import { usePopup } from '~/helpers/store';
export default function Upgrade() {
    const pState = usePopup((state) => state);
    const showPricingPopup = () => {
        pState.setShowPricingPopup(true);
    }
    return (
        <>
        <div className="px-2 py-1 pr-5 upgrade-btn"
        onClick={showPricingPopup}>
            <div className="inline-block h-[100%] mr-[5px] align-middle">
                <IoDiamondOutline></IoDiamondOutline>
            </div>
            <div className="inline-block">
                <div style={{
                    fontSize: "14px"
                }}>Upgrade Plan</div>
                <div className="sub-title" style={{
                    "color": "#00000080"
                }}>Get full acces</div>
            </div>
        </div>
        </>
    );
}